import { lightComponentColors } from "./componentColors";

export const lemmonPaper = {
  lemmonPaper: {
    "color-scheme": "light",
    primary: "#0e63d8",
    "primary-content": "#fff",

    secondary: "#101923",
    "secondary-content": "#fff",

    accent: "#0c0a09",
    "accent-content": "#fff",

    neutral: "#71717a",
    "neutral-content": "#fff",

    "base-100": "#ffffff",
    "base-200": "#ffffff",
    "base-300": "#f4f4f5",
    "base-content": "#27272a",
    "--form-control-background": "#f4f4f5",
    "--lemmon-switcher-background": "#f4f4f5",
    "--lemmon-switcher-border": "#e4e4e7",
    "--lemmon-switcher-indicator-background": "#ffffff",
    "--lemmon-switcher-indicator-overlay-background": "rgba(0, 0, 0, 0.03)",
    "--lemmon-switcher-indicator-shadow": "rgba(24, 24, 27, 0.12) 0px 1px 3px",

    info: "#0ea5e9",
    "info-content": "#001824",
    success: "#16a34a",
    "success-content": "#ffffff",
    warning: "#d97706",
    "warning-content": "#1a1300",
    error: "#dc2626",
    "error-content": "#ffffff",

    "--pos-card-bg": "#f4f4f5",
    "--pos-card-selected-bg": "#ffffff",
    "--pos-bar-color": "#0c0a09",
    "--body-bg-color": "#ffffff",
    "--pos-panel-bg": "#f4f4f5",
    "--pos-border-color": "#e4e4e7",
    "--pos-shadow-color": "#e4e4e7",
    "--pos-shadow-highlight": "rgba(0, 0, 0, 0.04)",
    ...lightComponentColors,
    "--floor-plan-background": "#f4f4f5",
    "--floor-plan-fixture-background": "#e4e4e7",
    "--floor-plan-table-free-background": "#d4d4d8",
    "--floor-plan-table-busy-background": "#0e63d8",
    "--order-card-background": "#ffffff",
    "--order-card-border": "#d4d4d8",
    "--order-card-dine-in-background": "#52525b",
  },
};
